/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuccessCreate = {
    properties: {
        yearStart: {
            type: 'number',
            isRequired: true,
        },
        yearEnd: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        successType: {
            type: 'SuccessType',
            isRequired: true,
        },
        text: {
            type: 'TranslationCreate',
            isRequired: true,
        },
    },
} as const;
